export function ScrollWindow(elem) {
  const rect = elem.getBoundingClientRect();
  const elemtop = rect.top + window.scrollY;
  document.documentElement.scrollTop = elemtop;
}
// 同意チェックボックス
export function submitButtonIsActive(id) {
  const check_flag = document.getElementById(id).checked;
  const submit_button = document.getElementById('submit-button');
  if(check_flag){
    submit_button.disabled = false;
  } else {
    submit_button.disabled = true;
  }
}

// ご注文日バリデーション
export function deliveryDateValid(type="order"){
  const input_calendar = document.getElementById('order_delivery_date');
  const input_calendar_value = input_calendar.value.replace(/\-/g,"/");
  const input_calendar_error = document.getElementById('error-delivery-date');
  const delivery_date_error_area = document.getElementById('delivery_date-error');
  const delivery_date_area_top = document.getElementById('delivery_date_area_top');
  const base_date = new Date().toString().match(/^.*(?= \d{2}:)/)[0];
  const bank_transfer = document.getElementById('bank_transfer');
  const calendar_date = new Date(input_calendar_value);
  const min_date = new Date(base_date);
  const max_date = new Date(base_date);
  min_date.setDate(min_date.getDate() + 7);
  let error_text = '本日より7日以降の１ヶ月間で日付指定が可能です。';
  let reset_error_text = '7日後からお届け希望日は設定できます。';
  let flag = true
  
  if(type === 'order'){
    max_date.setDate(max_date.getDate() + 30);
  }else{
    max_date.setDate(max_date.getDate() + 29);
  }
  
  if(type === 'subsc-order-edit') {
    const min_delivery_date = new Date(input_calendar.min.replace(/\-/g,"/"));
    if(min_delivery_date > calendar_date || calendar_date > max_date){
      flag = false;
    }
    reset_error_text = '次回以降の配送つきましても変更が反映されますので、ご了承ください。';
  }else if(type === 'order'){
    if(bank_transfer.checked){
      error_text = '銀行振込の場合には、お届け希望日を設定できません。';
      flag = false;
    }else if(min_date > calendar_date || calendar_date > max_date){
      flag = false;
      
    }
  }else if(type === 'subsc-order'){
    if(min_date > calendar_date || calendar_date > max_date){
    flag = false;
    }
  }

  if(flag){
    input_calendar.classList.remove('is-invalid');
    input_calendar_error.classList.remove('text-danger');
    input_calendar_error.classList.add('text-secondary');
    input_calendar_error.innerText = reset_error_text;
    delivery_date_error_area.classList.add("d-none");
    return true;
  }else{
    input_calendar.classList.add('is-invalid');
    input_calendar_error.classList.remove('text-secondary');
    input_calendar_error.classList.add('text-danger');
    input_calendar_error.innerText = error_text;
    delivery_date_error_area.classList.remove("d-none");
    delivery_date_error_area.innerText = 'お届け希望日時の入力に誤りがあります。';
    ScrollWindow(delivery_date_area_top);
  }
}

function changeColor(id, type) {
  let val_error = document.getElementById(id + '_error');
  if(type == 'red'){
    val_error.classList.remove('text-secondary');
    val_error.classList.add('text-danger');
  }else{
    val_error.classList.remove('text-danger');
    val_error.classList.add('text-secondary');
  }
}

function nullValid(id) {
  let val = document.getElementById(id);
  if(val == null) {
    return 1;
  }
  let val_error = document.getElementById(id + '_error');
  if(val.value == "") {
    changeColor(id, 'red');
    val.classList.add('is-invalid');
    val_error.innerText = '未入力です。';
    return 0;
  } else {
    changeColor(id, 'default');
    val.classList.remove('is-invalid');
    val_error.innerText = '必須'; 
    return 1;
  }
}
function customer_nullValid(id) {
  let val = document.getElementById(id);
  if(val == null) {
    return 1;
  }
  let val_error = document.getElementById(id + '_error');
  if(val.value == "") {
    val.classList.add('is-invalid');
    val_error.innerText = '未入力です。';
    return 0;
  } else {
    changeColor(id, 'default');
    val.classList.remove('is-invalid');
    val_error.innerText = ''; 
    return 1;
  }
}

function kanaValid(id) {
  let val = document.getElementById(id);
  if(val == null) {
    return 1;
  }
  let val_error = document.getElementById(id + '_error');
  if(val.value == "") {
    changeColor(id, 'red');
    val.classList.add('is-invalid');
    val_error.innerText = '未入力です。';
    return 0;
  } else if(!val.value.match(/^[ァ-ンヴー]*$/)){
    changeColor(id, 'red');
    val.classList.add('is-invalid');
    val_error.innerText = '全角カタカナで入力してください。';
    return 0;
  } else {
    changeColor(id, 'default');
    val.classList.remove('is-invalid');
    val_error.innerText = '必須'; 
    return 1;
  }
}
function customer_kanaValid(id) {
  let val = document.getElementById(id);
  if(val == null) {
    return 1;
  }
  let val_error = document.getElementById(id + '_error');
  if(val.value == "") {
    val.classList.add('is-invalid');
    val_error.innerText = '未入力です。';
    return 0;
  } else if(!val.value.match(/^[ァ-ンヴー]*$/)){
    val.classList.add('is-invalid');
    val_error.innerText = '全角カタカナで入力してください。';
    return 0;
  } else {
    val.classList.remove('is-invalid');
    val_error.innerText = ''; 
    return 1;
  }
}

function mailValid(id) {
  let val = document.getElementById(id);
  if(val == null) {
    return 1;
  }
  let val_error = document.getElementById(id + '_error');
  if(val.value == "") {
    changeColor(id, 'red');
    val.classList.add('is-invalid');
    val_error.innerText = '未入力です。';
    return 0;
  } else if(!val.value.match(/.+@.+\..+/)){
    changeColor(id, 'red');
    val.classList.add('is-invalid');
    val_error.innerText = 'メールアドレスが不正な値です。';
    return 0;
  } else {
    changeColor(id, 'default');
    val.classList.remove('is-invalid');
    val_error.innerText = '必須'; 
    return 1;
  }
}

function numberValid(id) {
  let val = document.getElementById(id);
  let val_error = document.getElementById(id + '_error');
  if(val_error == null) {
    return 1;
  }
  if(val.value == "") {
    changeColor(id, 'red');
    val.classList.add('is-invalid');
    val_error.innerText = '未入力です。';
    return 0;
  } else if(!val.value.match(/^\d{7}$/)){
    changeColor(id, 'red');
    val.classList.add('is-invalid');
    val_error.innerText = '7桁の数字で入力してください。';
    return 0;
  } else {
    changeColor(id, 'default');
    val.classList.remove('is-invalid');
    val_error.innerText = '必須 数字7桁でご入力ください。';
    return 1;
  }
}
function customer_numberValid(id) {
  let val = document.getElementById(id);
  let val_error = document.getElementById(id + '_error');
  if(val_error == null) {
    return 1;
  }
  if(val.value == "") {
    val.classList.add('is-invalid');
    val_error.innerText = '未入力です。';
    return 0;
  } else if(!val.value.match(/^\d{7}$/)){
    val.classList.add('is-invalid');
    val_error.innerText = '7桁の数字で入力してください。';
    return 0;
  } else {
    val.classList.remove('is-invalid');
    val_error.innerText = '数字7桁でご入力ください。';
    return 1;
  }
}

function telValid(id) {
  let val = document.getElementById(id);
  if(val == null) {
    return 1;
  }
  let val_error = document.getElementById(id + '_error');
  if(val.value == "") {
    changeColor(id, 'red');
    val.classList.add('is-invalid');
    val_error.innerText = '未入力です。';
    return 0;
  } else if(!val.value.match(/^(0{1}\d{9,10})$/)){
    changeColor(id, 'red');
    val.classList.add('is-invalid');
    val_error.innerText = 'ハイフンや空白なしで数字を続けてご入力ください。';
    return 0;
  } else {
    changeColor(id, 'default');
    val.classList.remove('is-invalid');
    val_error.innerText = '必須。- や空白なしで数字を続けてご入力ください。';
    return 1;
  }
}
function customer_telValid(id) {
  let val = document.getElementById(id);
  if(val == null) {
    return 1;
  }
  let val_error = document.getElementById(id + '_error');
  if(val.value == "") {
    val.classList.add('is-invalid');
    val_error.innerText = '未入力です。';
    return 0;
  } else if(!val.value.match(/^(0{1}\d{9,10})$/)){
    val.classList.add('is-invalid');
    val_error.innerText = 'ハイフンや空白なしで数字を続けてご入力ください。';
    return 0;
  } else {
    val.classList.remove('is-invalid');
    val_error.innerText = '- や空白なしで数字を続けてご入力ください。';
    return 1;
  }
}

function nameNullValid(id) {
  let val = document.getElementById(id);
  let name_input = document.getElementById(id + '_dd');

  if(val == null) {
    return 1;
  }
  if(val.value == "") {
    name_input.classList.add('is-invalid');
    return 0;
  } else {
    name_input.classList.remove('is-invalid');
    return 1;
  }
}

export function checkAddressValidate(type, customer_flag=false) {
  let flg = 1;
  flg &= nullValid(type + '_mailing_first_name');
  flg &= nullValid(type + '_mailing_last_name');
  flg &= kanaValid(type + '_mailing_first_name_kana');
  flg &= kanaValid(type + '_mailing_last_name_kana');
  flg &= numberValid(type + '_shipping_postal_code');
  flg &= nullValid(type + '_prefecture_id');
  flg &= nullValid(type + '_shipping_district');
  flg &= nullValid(type + '_shipping_address_1');
  flg &= telValid(type + '_tel');
  if(!customer_flag){
    flg &= mailValid(type + '_email');
  }
  return !!flg;
}

export function checkMailingNameValidate(type) {
  let flg = 1;
  flg &= nameNullValid(type + '_mailing_first_name');
  flg &= nameNullValid(type + '_mailing_last_name');
  flg &= nameNullValid(type + '_mailing_first_name_kana');
  flg &= nameNullValid(type + '_mailing_last_name_kana');
  return !!flg;
}

export function checkCustomerInfo() {
  let flg = 1;
  flg &= customer_nullValid('first_name');
  flg &= customer_nullValid('last_name');
  flg &= customer_kanaValid('first_name_kana');
  flg &= customer_kanaValid('last_name_kana');
  flg &= customer_numberValid('postal_code');
  flg &= customer_nullValid('prefecture_id');
  flg &= customer_nullValid('district');
  flg &= customer_nullValid('address_1');
  flg &= customer_telValid('tel');
  return !!flg;
}